module.exports = __webpack_public_path__ + "static/media/All Research.d6349ab3.csv";